import { IonContent } from '@ionic/react';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import styled from 'styled-components';

import { ApiUserType } from '@/modules/api';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { PreferencesListV3 } from '@/pages/Onboarding/components/PreferencesList';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';

export const PreferencesV3Styles = styled(OnboardingPage)`
  padding: 20px 0 16px;

  ion-content {
    &::part(scroll) {
      margin-top: 16px;
    }
  }
`;

export const PreferencesVariantV3: React.FC<{
  preloadCategories: ApiUserType['selected_categories'];
  categories: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormReturn<any>;
  handleNextStep: () => void;
}> = ({ preloadCategories, categories, form, handleNextStep }) => {
  return (
    <PreferencesV3Styles>
      <OnboardingTitle color="black">
        Select your ideal AI partner
      </OnboardingTitle>
      <OnboardingSubtitle color="neutral-black">
        You can change it later in the app
      </OnboardingSubtitle>

      <IonContent>
        <PreferencesListV3
          preloadCategories={preloadCategories}
          categories={categories}
          form={form}
        />
      </IonContent>

      <OnboardingFooter
        onContinue={handleNextStep}
        disabled={categories.length === 0}
      />
    </PreferencesV3Styles>
  );
};
